import axios from 'axios'
import { Message, Loading } from 'element-ui'

// 创建 Axios 实例
const service = axios.create({
  baseURL:process.env.VUE_APP_BASE_API, // 从环境变量取接口基础地址（如 .env.development）
  timeout: 8000, // 请求超时时间
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

let loadingInstance = null // 加载动画实例

// ========== 请求拦截器：添加加载动画 ==========
service.interceptors.request.use(
  config => {
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.1)'
    })
    return config
  },
  error => {
    if (loadingInstance) loadingInstance.close()
    Message.error(`请求配置错误: ${error.message}`)
    return Promise.reject(error)
  }
)

// ========== 响应拦截器：统一错误处理 + 关闭加载 ==========
service.interceptors.response.use(
  response => {
    if (loadingInstance) loadingInstance.close()
    const res = response.data

    // 假设后端成功标识为 code: 200（可根据实际接口调整）
    if (res.status == 1) {
      return res.data; // 成功时，返回业务数据（res.data）
    } else {
      // 非成功状态，提示错误并拒绝 Promise
      Message.error(res.msg || '操作失败');
      return Promise.reject(res.msg || '接口逻辑错误');
    }
  
  },
  error => {
    if (loadingInstance) loadingInstance.close()
    // 网络/HTTP 错误处理
    let errorMsg = '网络异常，请稍后重试'
    if (error.response) {
      switch (error.response.status) {
        case 404:
          errorMsg = '请求地址不存在'
          break
        case 500:
          errorMsg = '服务器内部错误'
          break
        default:
          errorMsg = `HTTP 错误: ${error.response.status}`
      }
    }
    Message.error(errorMsg)
    return Promise.reject(error)
  }
)

// ========== 封装常用请求方法 ==========
export const request = {
  // GET 请求
  get(url, params = {}, config = {}) {
    return service({ url, method: 'get', params, ...config })
  },

  // POST 请求
  post(url, data = {}, config = {}) {
    return service({ url, method: 'post', data, ...config })
  },

  // PUT 请求
  put(url, data = {}, config = {}) {
    return service({ url, method: 'put', data, ...config })
  },

  // DELETE 请求
  delete(url, params = {}, config = {}) {
    return service({ url, method: 'delete', params, ...config })
  },

  // 上传文件（可选）
  upload(url, file, onProgress) {
    const formData = new FormData()
    formData.append('file', file)
    return service({
      url,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: onProgress
    })
  }
}

export default service